<template>
  <div style="width: 600px;height: 400px; margin:200px auto;">
    <el-form :model="login" ref="loginForm" :rules="rules">
      <el-form-item prop="account" label="账号">
        <el-input v-model="login.account"></el-input>
      </el-form-item>
      <el-form-item prop="password" label="密码">
        <el-input type="password" v-model="login.password"></el-input>
      </el-form-item>
    </el-form>
    <div style="text-align: center;">
      <el-button :loading="loading" type="primary" @click="signIn">登录</el-button>
    </div>
  </div>
</template>
<script>
import {ref, reactive} from 'vue'
import axios from '../../request'
import {ElMessage} from 'element-plus'
import {useRouter} from 'vue-router'
import Cookies from 'js-cookie'

export default {
  setup() {
    const login = ref({
      account: '',
      password: ''
    })

    const loginForm = ref()
    const router = useRouter()

    const loading = ref(false)
    const signIn = () => {
      loginForm.value?.validate((passed) => {
        if (passed) {
          loading.value = true
          axios.post('/users/web_login', login.value).then(({token, user}) => {
            Cookies.set('token', token)
            Cookies.set('user', user.id)
            router.replace({name: 'ScenicSpots'})
          })
              .catch((e) => {
                console.log(e)
                ElMessage({
                  message: '登录失败'
                })
              })
              .finally(() =>
                  loading.value = false
              )
        }
      })
    }

    const rules = reactive({
      account: {
        required: true,
        message: '必须填写'
      },
      password: {
        required: true,
        message: '必须填写'
      }
    })

    return {
      login,
      loginForm,
      signIn,
      rules,
      loading
    }
  }
}
</script>
